import React from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";

const navItemClassName = (collapsed, isActive, disabled) =>
  `group flex items-center text-[13px] rounded-lg transition-colors duration-150 ${
    collapsed ? "justify-center px-2 py-2" : "px-2.5 py-2"
  } ${
    disabled
      ? "text-theme-text opacity-30 font-medium cursor-not-allowed"
      : isActive
        ? "bg-theme-main text-theme-primary font-semibold"
        : "text-theme-text opacity-55 font-medium hover:opacity-90 hover:bg-black hover:bg-opacity-5"
  }`;

const BadgeSpinner = ({ collapsed }) => (
  <span
    className={`inline-block animate-spin rounded-full border-2 border-theme-secondary border-t-theme-primary ${
      collapsed ? "h-3 w-3" : "h-3.5 w-3.5"
    }`}
    aria-label="Working"
  />
);

const SidebarNavItem = ({ item, isActive, onClick, collapsed = false, disabled = false }) => {
  const tooltipId = `nav-tooltip-${item.name.toLowerCase().replace(/\s+/g, "-")}`;
  const className = navItemClassName(collapsed, isActive, disabled);
  const showSpinner = Boolean(item.badgeSpinner);
  const badge = !showSpinner && item.badge > 0 ? (item.badge > 9 ? "9+" : item.badge) : null;
  const content = (
    <>
      <span className="relative flex-shrink-0">
        {item.icon}
        {showSpinner && collapsed && (
          <span className="absolute -right-1.5 -top-1.5">
            <BadgeSpinner collapsed />
          </span>
        )}
        {badge && collapsed && (
          <span className="absolute -right-1.5 -top-1.5 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-theme-primary px-1 text-[10px] font-bold leading-none text-theme-button">
            {badge}
          </span>
        )}
      </span>
      {!collapsed && <span className="ml-2.5 flex-1">{item.name}</span>}
      {showSpinner && !collapsed && (
        <span className="ml-auto flex items-center">
          <BadgeSpinner />
        </span>
      )}
      {badge && !collapsed && (
        <span className="ml-auto flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-theme-primary px-1.5 text-[10px] font-bold leading-none text-theme-button">
          {badge}
        </span>
      )}
    </>
  );

  return (
    <>
      {disabled ? (
        <span
          aria-disabled="true"
          className={className}
          data-tooltip-id={collapsed ? tooltipId : undefined}
          data-tooltip-content={collapsed ? item.name : undefined}
        >
          {content}
        </span>
      ) : (
        <Link
          to={item.href}
          onClick={onClick}
          className={className}
          data-tooltip-id={collapsed ? tooltipId : undefined}
          data-tooltip-content={collapsed ? item.name : undefined}
        >
          {content}
        </Link>
      )}
      {collapsed && <Tooltip id={tooltipId} place="right" className="z-50" />}
    </>
  );
};

export default SidebarNavItem;
